var React = require('react');

function ToqueInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"toque.inline"),React.createElement("g",{"id":"f5377801-30ab-44bb-959d-b995103efc9f","data-name":"Layer 2","key":1},React.createElement("g",{"id":"f8f930eb-b515-4306-9838-0b0119ab0b37","data-name":"Layer 1"},React.createElement("g",{"id":"a20c72b7-6ce9-43ea-acc6-02f3e1760075","data-name":"toque.inline"},React.createElement("path",{"d":"M19.49,25.08v6.5m-4.06-8.13v8.13m-4.06-6.5v6.5m-4.87,0H24.36m0-26.71a5.68,5.68,0,0,0-2.69.68,6.49,6.49,0,0,0-12.5,0,5.68,5.68,0,0,0-8.37,5A5.62,5.62,0,0,0,6.5,16.24V38.07H24.36V16.24a5.62,5.62,0,0,0,5.69-5.68A5.69,5.69,0,0,0,24.37,4.87Z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"}))))]);
}

ToqueInline.defaultProps = {"viewBox":"0 0 30.86 38.88"};

module.exports = ToqueInline;

ToqueInline.default = ToqueInline;
